<template>
  <el-table-column
      :index="startIndex"
      align="center"
      header-align="center"
      label="#"
      type="index"
      width="60"
  />
</template>

<script>
/**
 * 统一表格序号列：非分页表格从 1 开始，分页表格按当前页连续编号。
 */
export default {
  name: 'TableIndexColumn',
  props: {
    pageNo: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    /** Element UI 的数字型 index 表示当前页首行序号。 */
    startIndex() {
      const pageNo = Math.max(1, Number(this.pageNo) || 1)
      const pageSize = Math.max(0, Number(this.pageSize) || 0)
      return (pageNo - 1) * pageSize + 1
    },
  },
}
</script>
